import axios from 'axios'

export const NotificationApi = {
    async GetList(data){
        const response = await axios.post(`/api/notify/get/notifies`,data)
        return response
    },
    async GetSmsTable(data){
        const response = await axios.post(`/api/notify/table/smsstatus`,data)
        return response
    },
    async GetMailTable(data){
        const response = await axios.post(`/api/notify/table/mailstatus`,data)
        return response
    },
}